/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/nlp-integration-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/nlp-integration-api-client";
import type { GetLiveTopicsStationSettingsQueryResponse, GetLiveTopicsStationSettingsPathParams } from "../models/GetLiveTopicsStationSettings";

export function getGetLiveTopicsStationSettingsUrl(entityId: GetLiveTopicsStationSettingsPathParams["entityId"]) {
  const res = { method: 'GET', url: `/live-topics/station-settings/${entityId}` as const }
  return res
}

/**
 * @description Get settings for a specific station (client access)
 * @summary Get station settings
 * {@link /live-topics/station-settings/:entityId}
 */
export async function getLiveTopicsStationSettings(entityId: GetLiveTopicsStationSettingsPathParams["entityId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetLiveTopicsStationSettingsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetLiveTopicsStationSettingsUrl(entityId).url.toString(), ... requestConfig })
  return res.data
}